export default __webpack_public_path__ + "static/media/hp.6dd097ae.png";